import CryptoJS from "crypto-js";
import qs from "qs";

const baseUrl = "https://api.podcastindex.org/api/1.0";
const options = {
  key: "",
  secret: "",
};

const setKey = (key) => {
  console.log("Setting key", key);
  options.key = key;
  localStorage.setItem("key", key);
};

const setSecret = (secret) => {
  console.log("Setting secret", secret);

  options.secret = secret;
  localStorage.setItem("secret", secret);
};

const doTheFetch = () => {
  window.document.getElementById("results").innerHTML = "Loding ...";
  const authKey = options.key;
  const secretKey = options.secret;
  console.log("Options", options);
  const userAgent = "PI-playground";
  const apiHeaderTime = new Date().getTime() / 1000;
  const hash = CryptoJS.SHA1(authKey + secretKey + apiHeaderTime).toString(
    CryptoJS.enc.Hex
  );
  const headers = {
    "User-Agent": userAgent,
    "X-Auth-Key": authKey,
    "X-Auth-Date": apiHeaderTime,
    Authorization: hash,
  };
  console.log("HEADERS", headers);
  const url = document.getElementById("url").value;
  fetch(`${baseUrl}${url}`, { headers })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new Error(`Request failed with status: ${res.status}`);
      }
    })
    .then((json) => {
      window.document.getElementById("results").innerHTML =
        "Response:\n" + JSON.stringify(json, null, 4);
    })
    .catch((err) => {
      window.document.getElementById("results").innerHTML =
        "Response:\n" + JSON.stringify(err.message, null, 4);
    });
};
console.log(window.document);
window.addEventListener("load", () => {
  console.log("Window onload called");
  window.document.getElementById("theButton").onclick = () => {
    doTheFetch();
  };
  const keyElement = window.document.getElementById("key");
  keyElement.onblur = () => {
    setKey(window.document.getElementById("key").value);
  };
  setKey(localStorage.getItem("key") || "");
  keyElement.value = localStorage.getItem("key") || "";

  const secretElement = window.document.getElementById("secret");
  secretElement.onblur = () => {
    setSecret(window.document.getElementById("secret").value);
  };
  setSecret(localStorage.getItem("secret") || "");
  secretElement.value = localStorage.getItem("secret") || "";

  getEl("url").onblur = () => {
    const newPath = getEl("url").value;
    const currentUrl = new URL(window.location.href);
    const paramsObj = qs.parse(currentUrl.search.replace("?", ""));
    console.log("currentUrl.search :>> ", currentUrl.search);
    paramsObj.path = newPath;
    console.log("paramsObj", paramsObj);
    console.log("newPath", newPath);
    const newUrl = qs.stringify(paramsObj);
    currentUrl.search = newUrl;
    console.log("Setting url", newUrl);
    window.history.pushState(null, "", currentUrl);
  };
  getEl("url").addEventListener("keydown", (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      doTheFetch();
      return true;
    }
    return false;
  });

  const urlUrl = window.document.location.href;
  if (urlUrl) {
    const currentUrl = new URL(urlUrl);
    const paramsObj = qs.parse(currentUrl.search.replace("?", ""));
    const pathParam = paramsObj.path;
    console.log("params", currentUrl.searchParams);
    console.log("UrlUrl", urlUrl);
    if (pathParam) {
      console.log("setting ulr :>> ", pathParam);
      getEl("url").value = pathParam;
    }
  }
});

const getEl = (id) => window.document.getElementById(id);
